import { SITE_URL } from "../Api/config";
import User from "../assets/images/Avatar2.png";
import Female from "../assets/images/Female.png";
import Male from "../assets/images/Male.png";
import Profile from "../Booking/assets/Images/technician.png";

export const formatImageByGender = (gender, image, type) => {
  // If image is uploaded → return uploaded image
  if (image) {
    const uploaded = `${SITE_URL}uploads/photo/${image}`;
    return uploaded;
  }

//   let defaultImage = type == "createTechnician" ? Profile : User;

  // If gender missing AND no image → fallback avatar
  if (!gender) {
    return Male;
  }

  // If no image but gender exists → return gender avatar
  if (gender === "male") {
    const maleAvatar = Male;
    return maleAvatar;
  }

  if (gender === "female") {
    const femaleAvatar = Female;
    return femaleAvatar;
  }

  return Male;
};
